import { Page, Navbar, Link, Button } from "konsta/react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { appSlice } from "../../app/appSlice";
import { getColorForCode } from "../../app/colors";
import Wheel from "@uiw/react-color-wheel";
import { useState } from "react";

function CustomColor(props) {
  const dispatch = useAppDispatch();
  const editingCustomLightColor = props.editingCustomLightColor || "";
  const lightColor = useAppSelector(
    (state) => state.app[editingCustomLightColor + "Color"]
  );
  const lightColorObj = getColorForCode(lightColor);
  const [color, setColor] = useState(lightColorObj.color);
  const title = editingCustomLightColor
    .split(/(?=[A-Z])/)
    .map((key) => key.charAt(0).toUpperCase() + key.slice(1))
    .join(" ");

  return (
    <Page>
      <Navbar
        colors={{ bgIos: "bg-blue-trim", textIos: "text-white" }}
        translucent={false}
        title={title}
        left={
          <Link
            colors={{ navbarTextIos: "text-white" }}
            navbar
            onClick={() =>
              dispatch(appSlice.actions.setEditingCustomLightColor(""))
            }
          >
            Close
          </Link>
        }
      />
      <div className="p-4 h-[650px] flex flex-col items-center justify-between">
        <Wheel
          color={color}
          className="mt-10"
          width={270}
          height={270}
          pointer={(props) => {
            console.log("here");
            console.log(props);
            return (
              <div class="absolute" style={props.style}>
                <div
                  className={
                    props.prefixCls +
                    " w-5 h-5 -translate-y-1/2 -translate-x-1/2 rounded-full absolute border-2 border-white outline outline-1 outline-gray-400"
                  }
                  style={{
                    left: props.left,
                    top: props.top,
                    backgroundColor: props.color,
                  }}
                ></div>
              </div>
            );
          }}
          onChange={(color) => {
            setColor(color.hex);
          }}
        />
        <div className="">
          <Button
            large
            onClick={() => {
              dispatch(
                appSlice.actions[
                  "set" +
                    editingCustomLightColor.charAt(0).toUpperCase() +
                    editingCustomLightColor.slice(1) +
                    "ColorShow"
                ]("")
              );
              dispatch(
                appSlice.actions[
                  "set" +
                    editingCustomLightColor.charAt(0).toUpperCase() +
                    editingCustomLightColor.slice(1) +
                    "Color"
                ](color)
              );
            }}
          >
            Apply to {title}
          </Button>
          <div className="text-sm text-gray-700 py-4">
            APPLY SAME CUSTOM COLOR TO OTHER ZONES
          </div>
          {editingCustomLightColor !== "poolLights" ? (
            <Button
              large
              outline
              className="mb-2"
              onClick={() => {
                dispatch(appSlice.actions.setPoolLightsColorShow(""));
                dispatch(appSlice.actions.setPoolLightsColor(color));
              }}
            >
              Apply to Pool Lights
            </Button>
          ) : null}
          {editingCustomLightColor !== "spaLights" ? (
            <Button
              large
              outline
              className="mb-2"
              onClick={() => {
                dispatch(appSlice.actions.setSpaLightsColorShow(""));
                dispatch(appSlice.actions.setSpaLightsColor(color));
              }}
            >
              Apply to Spa Lights
            </Button>
          ) : null}
          {editingCustomLightColor !== "bubblerLights" ? (
            <Button
              large
              outline
              className="mb-2"
              onClick={() => {
                dispatch(appSlice.actions.setBubblerLightsColorShow(""));
                dispatch(appSlice.actions.setBubblerLightsColor(color));
              }}
            >
              Apply to Bubblers
            </Button>
          ) : null}
          {editingCustomLightColor !== "waterfallLights" ? (
            <Button
              large
              outline
              className="mb-2"
              onClick={() => {
                dispatch(appSlice.actions.setWaterfallLightsColorShow(""));
                dispatch(appSlice.actions.setWaterfallLightsColor(color));
              }}
            >
              Apply to Waterfall Features
            </Button>
          ) : null}
        </div>
      </div>
    </Page>
  );
}

export default CustomColor;
